"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolvePlaceholders = exports.Placeholder = exports.AbstractDataSourceResolver = exports.PlaceholderFormatter = exports.PlaceholderSourceType = exports.NO_FORMATTING = void 0;
const moment_1 = __importDefault(require("moment"));
const codedResource_1 = require("./codedResource");
const generalUtils_1 = require("./generalUtils");
const PLACEHOLDER_DELIMITER = "@@";
const PLACEHOLDER_SOURCE = "SOURCE_PART";
const PLACEHOLDER_FORMAT = "FORMAT_PART";
const PLACEHOLDER_TEMPLATE = `<${PLACEHOLDER_SOURCE}${PLACEHOLDER_DELIMITER}${PLACEHOLDER_FORMAT}>`;
const PLACEHOLDER_REGEXP = `(<([^@]+)(${PLACEHOLDER_DELIMITER})([^>]+)>)+`;
/**
 * A formatting constant which indicates that no formatting is required for the placeholder (just use the resolved value as-is)
 */
exports.NO_FORMATTING = { code: "NO_FORMATTING", pattern: "NO_FORMATTING" };
/**
 * Class representing the placeholders data option to implant in a string
 * description of the data value that should be formatted and implant
 */
class PlaceholderSourceType extends codedResource_1.CodedResource {
    constructor(code, description) {
        super(code);
        this.description = description;
    }
}
exports.PlaceholderSourceType = PlaceholderSourceType;
/**
 * Class representing the placeholders formats
 */
class PlaceholderFormatter extends codedResource_1.CodedResource {
    constructor(code, pattern) {
        super(code);
        this.pattern = pattern;
    }
}
exports.PlaceholderFormatter = PlaceholderFormatter;
/**
 * Abstract class for resolving the source type for it actual data to format
 */
class AbstractDataSourceResolver {
}
exports.AbstractDataSourceResolver = AbstractDataSourceResolver;
/**
 * Class representing the placeholders
 */
class Placeholder {
    constructor(sourceType, formatter) {
        this.sourceType = sourceType;
        this.formatter = formatter;
    }
    /**
     * translate the data source to its value and return the formatted string
     * @param resolver class to resolve the source type to its actual value
     * @returns {string} formatted value
     */
    // todo about expanding it from date into other types someday
    format(resolver) {
        let rawValue = resolver.resolve(this.sourceType);
        if (this.formatter.pattern === exports.NO_FORMATTING.pattern) {
            return rawValue;
        }
        // Convert to date and format.
        let dateData = (0, moment_1.default)(rawValue);
        return dateData.format(this.formatter.pattern);
    }
    /**
     * genrate the string representing the placeholder to implant in the full string
     * @returns {string} representation of the placeholder
     */
    generate() {
        return PLACEHOLDER_TEMPLATE.replace(PLACEHOLDER_SOURCE, this.sourceType.description).replace(PLACEHOLDER_FORMAT, this.formatter.pattern);
    }
}
exports.Placeholder = Placeholder;
/**
 * looking for every occurrence of the placeholder regexp and return the array of matches
 * @param fullFileNameStr file name template with all placeholders
 * @returns {RegExpMatchArray | null} array of all placeholders with valid pattern
 */
function getArrayOfPlaceholders(fullFileNameStr) {
    let placeHolderPatternRegex = new RegExp(PLACEHOLDER_REGEXP, "g");
    let placeholderArray = fullFileNameStr.match(placeHolderPatternRegex);
    if (placeholderArray === null) {
        return [];
    }
    return placeholderArray;
}
/**
 * the function split the placeholder string to the two components the data description and the formatter
 * for each part validate the string in case both parts valid generate and return the placeholder class
 * @param placeholderStr - string representing the placeholder
 * @param allSourceTypes - CodedResourceBundle of all optional sourceType - used for validation
 * @param allFormats - CodedResourceBundle of all optional placeholderFormatters - used for validation
 * @returns {Placeholder} placeholder class represented by the given string
 */
function getPlaceholder(placeholderStr, allSourceTypes, allFormats) {
    //subtract the placeholder string to the source representation part and the format representation part
    let placeholderComponentsArray = placeholderStr.split(PLACEHOLDER_DELIMITER);
    if (placeholderComponentsArray.length !== 2) {
        throw new Error(`Invalid placeholder pattern ${placeholderStr}. Placeholder string must contain 2 parts, but is split into: ${placeholderComponentsArray}`);
    }
    let sourceTypeStr = placeholderComponentsArray[0].substring(1);
    let formatStr = placeholderComponentsArray[1];
    formatStr = formatStr.substring(0, formatStr.length - 1);
    //get the sourceType constant by the string representation
    let placeholderSourceType = allSourceTypes.getByValue(sourceTypeStr, (item) => item.description);
    if (!placeholderSourceType) {
        throw new Error(`Invalid source type ${sourceTypeStr} in placeholder ${placeholderStr}`);
    }
    //get the relevant formatter constant by the string representation
    let placeholderFormatter = allFormats.getByValue(formatStr, (item) => item.pattern);
    if (!placeholderFormatter) {
        throw new Error(`Invalid formatter ${formatStr} in placeholder ${placeholderStr}`);
    }
    // construct and return Placeholder instance from the source type and formatter
    return new Placeholder(placeholderSourceType, placeholderFormatter);
}
/**
 * gets string with placeholders for each placeholder resolve the value format it and replace it with the placeholder
 * @param sourceStr - string that can contain placeholder string presentations
 * @param resolver - class tha implement the resolve function that return deta for any source type the full string contain
 * @param allSourceTypes - bundle of all valid source type
 * @param allFormats - bundle of all valid formats
 * @returns {string} full string after resolving and implant the formatted data
 */
function resolvePlaceholders(sourceStr, resolver, allSourceTypes, allFormats) {
    try {
        let placeholderArray = getArrayOfPlaceholders(sourceStr);
        let resolvedStr = sourceStr;
        for (let i = 0; i < placeholderArray.length; i++) {
            let placeholder = getPlaceholder(placeholderArray[i], allSourceTypes, allFormats);
            let formattedPlaceholder = placeholder.format(resolver);
            resolvedStr = resolvedStr.replace(placeholderArray[i], formattedPlaceholder);
        }
        return resolvedStr;
    }
    catch (e) {
        throw new generalUtils_1.BaseError(`Error in resolvePlaceholders: ${e}`, e);
    }
}
exports.resolvePlaceholders = resolvePlaceholders;
//# sourceMappingURL=placeholder.js.map